export const LAMP_BENEFIT_SERVICE_CODE = 787;
export const LAMP_BENEFIT_MAX_QUANTITY = 4;
export const DEFAULT_BENEFIT_MAX_QUANTITY = 1;

export const isLampBenefit = (benefit?: { serviceCode?: number }) =>
  benefit?.serviceCode === LAMP_BENEFIT_SERVICE_CODE;

export const getBenefitMaxQuantity = (benefit?: { serviceCode?: number }) =>
  isLampBenefit(benefit)
    ? LAMP_BENEFIT_MAX_QUANTITY
    : DEFAULT_BENEFIT_MAX_QUANTITY;

export const getBenefitQuantityFractions = (benefit?: {
  serviceCode?: number;
}) => (isLampBenefit(benefit) ? 0 : 2);

export const isQuantityOverLimit = (
  benefit: { serviceCode?: number } | undefined,
  quantity: number | undefined,
) =>
  typeof quantity === 'number' && quantity > getBenefitMaxQuantity(benefit);

export const isQuantityForbiddenDecimal = (
  benefit: { serviceCode?: number } | undefined,
  quantity: number | undefined,
) =>
  isLampBenefit(benefit) &&
  typeof quantity === 'number' &&
  !Number.isInteger(quantity);
